/**
 * Preguntarle a Android cuánto ocupan sus barras.
 *
 * La hoja de estilos define `--seguro-arriba` y compañía a partir de
 * `env(safe-area-inset-*)`, que es lo correcto en la web y en iOS. En el
 * WebView de Android ese valor informa **sólo el recorte físico de la
 * pantalla**: en un teléfono sin notch devuelve cero aunque la barra de estado
 * esté ocupando espacio, y la aplicación termina dibujada arriba de la hora.
 *
 * `MainActivity` expone los insets de verdad y además los empuja cuando
 * cambian. Esto es la otra mitad: leerlos apenas monta la aplicación, porque el
 * primer empuje del sistema suele ocurrir antes de que exista el documento y se
 * pierde sin avisar.
 *
 * Fuera de Android no hay nada que preguntar y las variables quedan como están.
 */
interface PuenteInsets {
  arriba: () => number;
  abajo: () => number;
  izquierda: () => number;
  derecha: () => number;
}

/** Lee lo que informa Android. Devuelve si encontró el puente. */
export function aplicarInsetsDeAndroid(ventana: Window = window): boolean {
  const puente = (ventana as unknown as { BoinaInsets?: PuenteInsets }).BoinaInsets;
  if (!puente) return false;

  const estilo = ventana.document.documentElement.style;
  const poner = (nombre: string, valor: unknown) => {
    // Un puente roto o a medio inicializar puede devolver cualquier cosa. Un
    // `NaNpx` en una variable CSS no falla: hace que todo el `calc()` que la use
    // se descarte en silencio, y el problema reaparece sin dejar rastro.
    if (typeof valor !== 'number' || !Number.isFinite(valor) || valor < 0) return;
    estilo.setProperty(nombre, `${valor}px`);
  };

  poner('--seguro-arriba', puente.arriba());
  poner('--seguro-abajo', puente.abajo());
  poner('--seguro-izq', puente.izquierda());
  poner('--seguro-der', puente.derecha());
  return true;
}
